import Nullstack from 'nullstack';
export default function IconGlassFull({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-glass-full",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "21",
    x2: "16",
    y2: "21"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "15",
    x2: "12",
    y2: "21"
  }), "   ", Nullstack.element("path", {
    d: "M17 3l1 7c0 3.012 -2.686 5 -6 5s-6 -1.988 -6 -5l1 -7h10z"
  }), "   ", Nullstack.element("path", {
    d: "M6 10a5 5 0 0 1 6 0a5 5 0 0 0 6 0"
  }), " ");
}